export const locales = [
  {
    code: "ru",
    file: "ru.json",
    name: "Русский",
  },
  {
    code: "en",
    file: "en.json",
    name: "English",
  },
  {
    code: "uz",
    file: "uz.json",
    name: "O'zbek",
  },
  {
    code: "in",
    file: "hi_IN.json",
    name: "India",
  },
  {
    code: "pt",
    file: "pt.json",
    name: "Portugal",
  },
  {
    code: "es",
    file: "es_ES.json",
    name: "Spain",
  },
];
